import React, { Component } from 'react';
import { Route } from "react-router-dom";
import Home from "./components/Home/Home";
import CreateRide from "./components/Rides/CreateRide";
import RidePage from "./components/Rides/RidePage";
import OwnerPage from "./components/Profile/OwnerPage";
import RiderPage from "./components/Profile/RiderPage";
import Chat from "./components/Chat/chat"
import Auth from './auth/Auth';
import Callback from './Callback/Callback';
import Success from './components/Success/success';
import RateRide from "./components/Rides/RateRide";
import store from './reducers/redux-index';
import HelpPage from "./components/Help/HelpPage";

import './scss/App.scss';
import AddRide from './components/Rides/AddRide';

const auth = new Auth();

const handleAuthentication = ({ location }) => {
  if (/access_token|id_token|error/.test(location.hash)) {
    auth.handleAuthentication();
  }
}

class App extends Component {
  componentDidMount() {
    if (localStorage.getItem('isLoggedIn') === 'true') {
      if (new Date().getTime() > parseInt(localStorage.getItem("expiresAt"))) {
        auth.renewSession();
      }
      else {
        store.dispatch({
          type: "LOGGED_IN",
          payload: {
            token: localStorage.getItem('accessToken'),
            tokenId: localStorage.getItem("idToken"),
            expiresAt: localStorage.getItem("expiresAt"),
            userProfile: JSON.parse(localStorage.getItem('userProfile'))
          }
        })
      }
    }
  }

  render() {
    return (
      <div className="App">
        <Route exact={true} path="/" render={(props) => <Home auth={auth} {...props} />} />
        <Route exact={true} path="/add" render={(props) => <CreateRide auth={auth} {...props} />} />
        <Route exact={true} path="/addRide" render={(props) => <AddRide auth={auth} {...props} />} />
        <Route exact={true} path="/updateRide" render={(props) => <AddRide auth={auth} {...props} />} />
        <Route exact={true} path="/ride/:rideId" render={(props) => <RidePage auth={auth} {...props} />} />
        <Route exact={true} path="/owner/:ownerId" render={(props) => <OwnerPage auth={auth} {...props} />} />
        <Route exact={true} path="/rider" render={(props) => <RiderPage auth={auth} {...props} />} />
        <Route exact={true} path="/chat" render={(props) => <Chat auth={auth} {...props} />} />
        <Route exact={true} path="/success" render={(props) => <Success {...props} />} />
        <Route exact={true} path="/rate/:rateId" component={RateRide} />
        <Route exact={true} path="/aide" render={(props) => <HelpPage auth={auth} {...props} />} />
        <Route path="/callback" render={(props) => {
          handleAuthentication(props);
          return <Callback {...props} />
        }} />
      </div>
    );
  }
}

export default App;
